export default __webpack_public_path__ + "static/barcamp_logo-e17c0fe6bcac705c1ea9ea343cd12957.svg";